import { render, staticRenderFns } from "./ModalAlertConfirm.vue?vue&type=template&id=65022f76&scoped=true&"
import script from "./ModalAlertConfirm.vue?vue&type=script&lang=js&"
export * from "./ModalAlertConfirm.vue?vue&type=script&lang=js&"
import style0 from "./ModalAlertConfirm.vue?vue&type=style&index=0&id=65022f76&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65022f76",
  null
  
)

export default component.exports